// extracted by mini-css-extract-plugin
export var quantityInput = "_eg-0";